var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sumjcenter"},[(_vm.errorVisible)?_c('el-alert',{staticClass:"sumjcenter1",attrs:{"title":_vm.errorText,"type":"error","center":"","show-icon":"","closable":false}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }